import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function AnnouncementsPage() {
  return <InstituteCrudPage config={entityConfigs['announcements']} />;
}
